import axios from "axios";
import {
  exception,
  httpSuccess,
  success,
  unauthorized,
} from "../common/errorCode";
import { purgeData, store, storeRefresh } from "..";
import { useNavigate } from "react-router-dom";
import { refreshTokenUrl, uniIdLoginUrl } from "../common/url";
import { useSelector, useDispatch } from "react-redux";
import { loginSession } from "../actions/session";
import { CLIENTID } from "../common/constant";
import { loginByUniId } from "../common/utils";
import { updateLoading } from "../actions/loading";
// import { useTranslation } from "react-i18next";
import i18n from "../i18n";
export async function restGetApi(url) {
  console.log("URL: " + url);
  let data = null;
  try {
    const apiUrl = url ?? "";
    let data = await axios
      .get(apiUrl)
      .then((repos) => {
        console.log(JSON.stringify(repos));
        return repos;
      })
      .catch((error) => {
        console.log(JSON.stringify(error));
        return exception;
      });
  } catch (Ex) {
    console.log("Exp: " + Ex);
  }
  return data;
}

export async function restPostApi(url, body, tokenInfo) {
  let storeGet = store;

  console.log("getI18n: " + JSON.stringify(i18n.language));

  console.log("URL: " + url);
  console.log("BODY: " + JSON.stringify(body));
  let data = null;
  try {
    // get token
    console.log("tokenInfo: " + JSON.stringify(tokenInfo));
    let token = tokenInfo != null ? tokenInfo.token : "";
    // let refreshToken = tokenInfo != null ? tokenInfo.refreshToken : "";

    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Accept-Language": i18n.language === "la" ? "lo" : "en",
      Authorization: "Bearer " + token,
    };

    const apiUrl = url ?? "";
    storeGet.dispatch(updateLoading(true));

    data = await axios
      .post(apiUrl, body, {
        headers: headers,
      })
      .then((repos) => {
        storeGet.dispatch(updateLoading(false));
        console.log("RES: " + JSON.stringify(repos));
        return repos;
      })
      .catch(async (error) => {
        storeGet.dispatch(updateLoading(false));
        console.log("RES: " + JSON.stringify(error));
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === unauthorized) {
            // refresh token
            let refreshRes = await reloadSession(tokenInfo);
            if (refreshRes != null) {
              console.log("status: " + refreshRes.status);
              if (refreshRes.status === httpSuccess) {
                console.log("errorCode: " + refreshRes.data.errorCode);
                if (refreshRes.data.errorCode === success) {
                  let tokenInfo = {
                    token: refreshRes.data.data.token,
                    refreshToken: refreshRes.data.data.refreshToken,
                  };

                  storeGet.dispatch(loginSession(tokenInfo));
                  return restPostApi(url, body, tokenInfo);
                } else {
                  console.log("message: " + refreshRes.data);
                }
              } else {
                console.log("message: " + refreshRes.data);
              }
            }

            // return unauthorized;
            console.log("LOG OUT");
            purgeData();
            loginByUniId();
          }
          return error.response;
        }
        return null;
      });
  } catch (Ex) {
    console.log("Exp: " + Ex);
  }
  return data;
}

export async function restPostNotShowLoadingApi(url, body, tokenInfo) {
  let storeGet = store;

  console.log("URL: " + url);
  console.log("BODY: " + JSON.stringify(body));
  let data = null;
  try {
    // get token
    console.log("tokenInfo: " + JSON.stringify(tokenInfo));
    let token = tokenInfo != null ? tokenInfo.token : "";
    let refreshToken = tokenInfo != null ? tokenInfo.refreshToken : "";

    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Accept-Language": i18n.language === "la" ? "lo" : "en",
      Authorization: "Bearer " + token,
    };

    const apiUrl = url ?? "";

    data = await axios
      .post(apiUrl, body, {
        headers: headers,
      })
      .then((repos) => {
        console.log("RES: " + JSON.stringify(repos));
        return repos;
      })
      .catch(async (error) => {
        console.log("RES: " + JSON.stringify(error));
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status === unauthorized) {
            // refresh token
            let refreshRes = await reloadSession(tokenInfo);
            if (refreshRes != null) {
              console.log("status: " + refreshRes.status);
              if (refreshRes.status === httpSuccess) {
                console.log("errorCode: " + refreshRes.data.errorCode);
                if (refreshRes.data.errorCode === success) {
                  let tokenInfo = {
                    token: refreshRes.data.data.token,
                    refreshToken: refreshRes.data.data.refreshToken,
                  };

                  storeGet.dispatch(loginSession(tokenInfo));
                  return restPostNotShowLoadingApi(url, body, tokenInfo);
                } else {
                  console.log("message: " + refreshRes.data);
                }
              } else {
                console.log("message: " + refreshRes.data);
              }
            }

            // return unauthorized;
            console.log("LOG OUT");
            purgeData();
            loginByUniId();
          }
          return error.response;
        }
        return null;
      });
  } catch (Ex) {
    console.log("Exp: " + Ex);
  }
  return data;
}

async function reloadSession(tokenInfo) {
  let storeGet = store;
  console.log("URL: " + refreshTokenUrl);
  let data = null;
  try {
    // get token
    console.log("tokenInfo: " + JSON.stringify(tokenInfo));
    let token = tokenInfo != null ? tokenInfo.token : "";
    let refreshToken = tokenInfo != null ? tokenInfo.refreshToken : "";

    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
      "Accept-Language": i18n.language === "la" ? "lo" : "en",
      Authorization: "Bearer " + token,
    };

    const apiUrl = refreshTokenUrl;
    let body = {
      refreshToken: tokenInfo.refreshToken,
    };
    storeGet.dispatch(updateLoading(true));
    data = await axios
      .post(apiUrl, body, {
        headers: headers,
      })
      .then((repos) => {
        storeGet.dispatch(updateLoading(false));
        console.log(JSON.stringify(repos));
        return repos;
      })
      .catch((error) => {
        storeGet.dispatch(updateLoading(false));
        console.log(JSON.stringify(error));
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);

          if (error.response.status == unauthorized) {
            // return unauthorized;
            console.log("LOG OUT");
            purgeData();
            loginByUniId();
          }
          return error.response;
        }
        return null;
      });
  } catch (Ex) {
    console.log("Exp: " + Ex);
  }
  return data;
}
